import React, {
  useEffect,
  useState,
} from "react";

import api from "../../api/api";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Stack,
  InputAdornment,
  Typography,
  Box,
  Chip,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";

import Swal from "sweetalert2";

import { useAcademicYear } from "../../AcademicYearContext";


const SalaryAdvance = () => {

  const {
    selectedYear,
  } = useAcademicYear();


  const [
    open,
    setOpen,
  ] = useState(false);


  const [
    teacherList,
    setTeacherList,
  ] = useState([]);


  const [
    supportStaffList,
    setSupportStaffList,
  ] = useState([]);


  const [
    data,
    setData,
  ] = useState([]);


  const [
    advance,
    setAdvance,
  ] = useState({

    teacher: null,

    support_staff: null,

    amount: "",

    reason: "",

    month: "",

  });


  const [
    loading,
    setLoading,
  ] = useState(false);


  const [
    filterText,
    setFilterText,
  ] = useState("");


  const [
    editId,
    setEditId,
  ] = useState(null);


  const [
    page,
    setPage,
  ] = useState(0);


  const [
    rowsPerPage,
  ] = useState(6);


  const monthOptions = [

    "January",

    "February",

    "March",

    "April",

    "May",

    "June",

    "July",

    "August",

    "September",

    "October",

    "November",

    "December",

  ];


  useEffect(() => {

    if (selectedYear?.id) {

      fetchInitialData();

    }

  }, [

    selectedYear?.id,

  ]);


  const fetchInitialData = async () => {

    try {

      const [

        teachers,

        staff,

        advances,

      ] = await Promise.all([

        api.get(
          "/api/users/teacher-data/"
        ),

        api.get(
          "/supportstaff/"
        ),

        api.get(
          "/salary-advances/",
          {
            params: {
              academic_year:
                selectedYear?.id,
            },
          }
        ),

      ]);


      const teacherData =

        Array.isArray(
          teachers.data
        )

          ? teachers.data

          : teachers.data?.results || [];


      const staffData =

        Array.isArray(
          staff.data
        )

          ? staff.data

          : staff.data?.results || [];


      const advanceData =

        Array.isArray(
          advances.data
        )

          ? advances.data

          : advances.data?.results || [];


      setTeacherList(
        teacherData
      );


      setSupportStaffList(
        staffData
      );


      setData(
        advanceData
      );


    } catch (error) {

      console.error(
        "SALARY ADVANCE FETCH ERROR:",
        error.response?.data || error
      );

      Swal.fire(
        "Error",
        "Failed to load salary advances.",
        "error"
      );

    }

  };


  const handleOpen = () => {

    setOpen(true);


    setAdvance({

      teacher: null,

      support_staff: null,

      amount: "",

      reason: "",

      month: "",

    });


    setEditId(null);

  };


  const handleClose = () => {

    setOpen(false);

  };

  const handleSubmit = async () => {
    if (!selectedYear?.id) {
        return Swal.fire(
            "Error",
            "Please select an academic year.",
            "error"
        );
    }

    if (!advance.teacher && !advance.support_staff) {
        return Swal.fire(
            "Error",
            "Select either a teacher or a support staff.",
            "error"
        );
    }

    if (!advance.month) {
        return Swal.fire(
            "Error",
            "Please select month.",
            "error"
        );
    }

    if (!advance.amount || Number(advance.amount) <= 0) {
        return Swal.fire(
            "Error",
            "Please enter a valid advance amount.",
            "error"
        );
    }

    setLoading(true);

    const payload = {
        teacher: advance.teacher?.id || null,
        support_staff: advance.support_staff?.id || null,
        academic_year: selectedYear.id,
        amount: Number(advance.amount),
        reason: advance.reason,
        month: advance.month,
    };

    try {
        if (editId) {
            await api.put(
                `/salary-advances/${editId}/`,
                payload
            );

            await Swal.fire(
                "Success",
                "Advance updated successfully.",
                "success"
            );
        } else {
            await api.post(
                "/salary-advances/",
                payload
            );

            await Swal.fire(
                "Success",
                "Advance added successfully.",
                "success"
            );
        }

        await fetchInitialData();
        handleClose();
    } catch (error) {
        console.error(
            "SALARY ADVANCE SAVE ERROR:",
            error.response?.data || error
        );

        Swal.fire(
            "Error",
            error.response?.data
                ? JSON.stringify(error.response.data)
                : "Something went wrong.",
            "error"
        );
    } finally {
        setLoading(false);
    }
};

  const handleEdit = (item) => {

    setAdvance({

      teacher:

        item.teacher

          ? {

              id:

                item.teacher,

              full_name:

                item.teacher_name,

            }

          : null,


      support_staff:

        item.support_staff

          ? {

              id:

                item.support_staff,

              full_name:

                item.support_staff_name,

            }

          : null,


      amount:

        item.amount,


      reason:

        item.reason || "",


      month:

        item.month || "",

    });


    setEditId(

      item.id

    );


    setOpen(true);

  };


  const handleDelete = (id) => {

    Swal.fire({

      title:

        "Are you sure?",

      text:

        "This will permanently delete the record.",

      icon:

        "warning",

      showCancelButton:

        true,

      confirmButtonText:

        "Yes, delete it",

    }).then(

      async (result) => {

        if (

          result.isConfirmed

        ) {

          try {

            await api.delete(

              `/salary-advances/${id}/`

            );


            Swal.fire(

              "Deleted!",

              "Advance has been deleted.",

              "success"

            );


            fetchInitialData();


          } catch (error) {

            Swal.fire(

              "Error",

              "Failed to delete.",

              "error"

            );

          }

        }

      }

    );

  };


  const filteredData =

    data.filter(

      (row) => {

        const term =

          filterText

            .toLowerCase();


        return (

          (

            row.teacher_name &&

            row.teacher_name

              .toLowerCase()

              .includes(term)

          ) ||

          (

            row.support_staff_name &&

            row.support_staff_name

              .toLowerCase()

              .includes(term)

          ) ||

          (

            row.month &&

            row.month

              .toLowerCase()

              .includes(term)

          ) ||

          (

            row.status &&

            row.status

              .toLowerCase()

              .includes(term)

          )

        );

      }

    );


  const formatMoney = (

    value

  ) => {

    return `$${Number(

      value || 0

    ).toLocaleString(

      "en-US",

      {

        minimumFractionDigits: 2,

        maximumFractionDigits: 2,

      }

    )}`;

  };


  return (

    <Box

      sx={{

        backgroundColor:

          "#f5f5f5",

        padding: 3,

      }}

    >

      <Box

        sx={{

          display:

            "flex",

          alignItems:

            "center",

          marginBottom: 2,

          gap: 2,

          flexWrap:

            "wrap",

        }}

      >

        <Tooltip

          title="Add Salary Advance"

        >

          <IconButton

            color="primary"

            onClick={

              handleOpen

            }

          >

            <MonetizationOnIcon

              sx={{

                color:

                  "green",

                fontSize:

                  32,

              }}

            />

          </IconButton>

        </Tooltip>


        <TextField

          placeholder="Search by name, month or status"

          value={

            filterText

          }

          onChange={

            (e) =>

              setFilterText(

                e.target.value

              )

          }

          InputProps={{

            startAdornment: (

              <InputAdornment

                position="start"

              >

                <SearchIcon />

              </InputAdornment>

            ),

          }}

          sx={{

            width:

              350,

            maxWidth:

              "100%",

          }}

        />

      </Box>


      <Dialog

        open={open}

        onClose={

          handleClose

        }

        maxWidth="sm"

        fullWidth

      >

        <DialogTitle>

          {editId

            ? "Edit Salary Advance"

            : "Add Salary Advance"}

        </DialogTitle>


        <DialogContent

          dividers

        >

          <Stack

            spacing={2}

          >

            <Autocomplete

              options={

                teacherList

              }

              getOptionLabel={

                (option) =>

                  option.full_name || ""

              }

              value={

                advance.teacher

              }

              onChange={

                (event, newValue) =>

                  setAdvance({

                    ...advance,

                    teacher:

                      newValue,

                    support_staff:

                      null,

                  })

              }

              renderInput={

                (params) => (

                  <TextField

                    {...params}

                    label="Teacher"

                    fullWidth

                  />

                )

              }

              disabled={

                !!advance.support_staff

              }

            />


            <Autocomplete

              options={

                supportStaffList

              }

              getOptionLabel={

                (option) =>

                  option.full_name || ""

              }

              value={

                advance.support_staff

              }

              onChange={

                (event, newValue) =>

                  setAdvance({

                    ...advance,

                    support_staff:

                      newValue,

                    teacher:

                      null,

                  })

              }

              renderInput={

                (params) => (

                  <TextField

                    {...params}

                    label="Support Staff"

                    fullWidth

                  />

                )

              }

              disabled={

                !!advance.teacher

              }

            />


            <TextField

              label="Amount"

              type="number"

              value={

                advance.amount

              }

              onChange={

                (e) =>

                  setAdvance({

                    ...advance,

                    amount:

                      e.target.value,

                  })

              }

              fullWidth

            />


            <Autocomplete

              options={

                monthOptions

              }

              getOptionLabel={

                (option) =>

                  option

              }

              value={

                advance.month

              }

              onChange={

                (event, newValue) =>

                  setAdvance({

                    ...advance,

                    month:

                      newValue || "",

                  })

              }

              renderInput={

                (params) => (

                  <TextField

                    {...params}

                    label="Month"

                    fullWidth

                  />

                )

              }

            />


            <TextField

              label="Reason"

              multiline

              rows={3}

              value={

                advance.reason

              }

              onChange={

                (e) =>

                  setAdvance({

                    ...advance,

                    reason:

                      e.target.value,

                  })

              }

              fullWidth

            />

          </Stack>

        </DialogContent>


        <DialogActions>

          <Button

            onClick={

              handleClose

            }

          >

            Cancel

          </Button>


          <Button

            onClick={

              handleSubmit

            }

            variant="contained"

            color="primary"

            disabled={

              loading

            }

          >

            {loading ? (

              <CircularProgress

                size={24}

              />

            ) : (

              editId

                ? "Update"

                : "Submit"

            )}

          </Button>

        </DialogActions>

      </Dialog>


      <TableContainer

        component={Paper}

        sx={{

          overflowX:

            "auto",

        }}

      >

        <Table

          sx={{

            minWidth:

              1250,

          }}

        >

          <TableHead>

            <TableRow

              sx={{

                backgroundColor:

                  "#003366",

              }}

            >

              <TableCell

                sx={{

                  color:

                    "#fff",

                  fontWeight:

                    "bold",

                }}

              >

                Teacher

              </TableCell>


              <TableCell

                sx={{

                  color:

                    "#fff",

                  fontWeight:

                    "bold",

                }}

              >

                Support Staff

              </TableCell>


              <TableCell

                sx={{

                  color:

                    "#fff",

                  fontWeight:

                    "bold",

                }}

              >

                Advance Amount

              </TableCell>


              <TableCell

                sx={{

                  color:

                    "#fff",

                  fontWeight:

                    "bold",

                }}

              >

                Amount Taken

              </TableCell>


              <TableCell

                sx={{

                  color:

                    "#fff",

                  fontWeight:

                    "bold",

                }}

              >

                Remaining Balance

              </TableCell>


              <TableCell

                sx={{

                  color:

                    "#fff",

                  fontWeight:

                    "bold",

                }}

              >

                Month

              </TableCell>


              <TableCell

                sx={{

                  color:

                    "#fff",

                  fontWeight:

                    "bold",

                }}

              >

                Year

              </TableCell>


              <TableCell

                sx={{

                  color:

                    "#fff",

                  fontWeight:

                    "bold",

                }}

              >

                Status

              </TableCell>


              <TableCell

                sx={{

                  color:

                    "#fff",

                  fontWeight:

                    "bold",

                }}

              >

                Reason

              </TableCell>


              <TableCell

                sx={{

                  color:

                    "#fff",

                  fontWeight:

                    "bold",

                }}

              >

                Actions

              </TableCell>

            </TableRow>

          </TableHead>


          <TableBody>

            {filteredData

              .slice(

                page *

                  rowsPerPage,

                page *

                  rowsPerPage +

                  rowsPerPage

              )

              .map(

                (row) => (

                  <TableRow

                    key={

                      row.id

                    }

                    hover

                  >

                    <TableCell>

                      {row.teacher_name ||

                        "-"}

                    </TableCell>


                    <TableCell>

                      {row.support_staff_name ||

                        "-"}

                    </TableCell>


                    <TableCell>

                      {formatMoney(

                        row.amount

                      )}

                    </TableCell>


                    <TableCell>

                      {formatMoney(

                        row.total_deducted

                      )}

                    </TableCell>


                    <TableCell>

                      <Typography

                        sx={{

                          fontWeight:

                            "bold",

                          color:

                            Number(

                              row.remaining_balance

                            ) > 0

                              ? "orange"

                              : "green",

                        }}

                      >

                        {formatMoney(

                          row.remaining_balance

                        )}

                      </Typography>

                    </TableCell>


                    <TableCell>

                      {row.month ||

                        "-"}

                    </TableCell>


                    <TableCell>

                      {selectedYear?.name ||

                        "-"}

                    </TableCell>


                    <TableCell>

                      <Chip

                        label={

                          row.status ||

                          (

                            Number(

                              row.remaining_balance

                            ) > 0

                              ? "Pending"

                              : "Fully Taken"

                          )

                        }

                        color={

                          (

                            row.status ===

                            "Fully Taken" ||

                            (

                              !row.status &&

                              Number(

                                row.remaining_balance

                              ) <= 0

                            )

                          )

                            ? "success"

                            : "warning"

                        }

                        size="small"

                      />

                    </TableCell>


                    <TableCell>

                      {row.reason ||

                        "-"}

                    </TableCell>


                    <TableCell>

                      <Stack

                        direction="row"

                        spacing={1}

                      >

                        <Button

                          onClick={() =>

                            handleEdit(

                              row

                            )

                          }

                          variant="outlined"

                          size="small"

                        >

                          Edit

                        </Button>


                        <Button

                          onClick={() =>

                            handleDelete(

                              row.id

                            )

                          }

                          variant="outlined"

                          color="error"

                          size="small"

                        >

                          Delete

                        </Button>

                      </Stack>

                    </TableCell>

                  </TableRow>

                )

              )}


            {filteredData.length === 0 && (

              <TableRow>

                <TableCell

                  colSpan={10}

                  align="center"

                >

                  No records found.

                </TableCell>

              </TableRow>

            )}

          </TableBody>

        </Table>


        <TablePagination

          component="div"

          count={

            filteredData.length

          }

          page={

            page

          }

          onPageChange={

            (

              event,

              newPage

            ) =>

              setPage(

                newPage

              )

          }

          rowsPerPage={

            rowsPerPage

          }

          rowsPerPageOptions={[

            6,

          ]}

        />

      </TableContainer>

    </Box>

  );

};


export default SalaryAdvance;

